export default {
  "content": "<path d=\"M1.696 10.269a.843.843 0 010-.533 8.754 8.754 0 0116.607-.005.843.843 0 010 .533 8.754 8.754 0 01-16.607.005z\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M12.5 10a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "20",
    "height": "20",
    "viewBox": "0 0 20 20",
    "fill": "none"
  }
};